import { useNavigate } from "react-router-dom";
import { FiLock } from "react-icons/fi";

function PurchasedSection({ ppv_event }: any) {
  const navigate = useNavigate();

  const handlePurchaseButton = () => {
    navigate(`/ppv/details/${ppv_event?.slug}`);
  };

  return (
    <div className="flex items-center justify-center min-h-screen p-5 bg-black">
      <div className="w-[80%] max-lg:w-[95%] mx-auto overflow-hidden bg-gray-900 border border-gray-800 shadow-2xl rounded-2xl">
        <div className="flex flex-col sm:flex-row">
          {/* Banner */}
          <div className="relative sm:w-1/2">
            <img
              src={ppv_event?.bannerImage}
              alt={ppv_event?.title}
              className="w-full h-[280px] sm:h-[600px] object-cover"
            />
            {/* fade so the image blends into the card instead of ending in a hard edge */}
            <div className="absolute inset-0 bg-gradient-to-t sm:bg-gradient-to-r from-gray-900 via-transparent to-transparent" />
          </div>

          {/* Content */}
          <div className="flex flex-col justify-center flex-1 gap-6 px-8 py-10 sm:px-12 sm:py-10 text-center sm:text-left">
            <p className="text-2xl max-lg:text-xl font-semibold tracking-wide text-gray-200">
              {ppv_event?.title}
            </p>

            <div className="flex items-center justify-center sm:justify-start gap-3 mx-auto sm:mx-0">
              <span className="flex items-center justify-center w-14 h-14 rounded-full bg-[#f30543]/15 text-[#f30543]">
                <FiLock size={28} />
              </span>
              <h1 className="text-[32px] max-lg:text-[24px] font-bold text-white">
                Access Restricted
              </h1>
            </div>

            <p className="text-lg leading-relaxed text-gray-400 sm:max-w-md">
              This is a pay-per-view event. Purchase a ticket to unlock the
              live broadcast and watch it in full.
            </p>

            <button
              className="w-full sm:w-auto px-12 py-4 mx-auto sm:mx-0 text-lg font-semibold text-white transition-colors bg-[#f30543] rounded-full hover:bg-[#d40339]"
              onClick={handlePurchaseButton}
            >
              Purchase Event
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PurchasedSection;
